// Field names query_elements understands: type name storey material volume area
// q:<QuantityName> p:<PropertySet>.<Property> (bare property names search every pset).
import { areaOf, prop, quantity, volumeOf, type PropsElement } from '../props';

export function fieldValue(e: PropsElement, field: string): string | number | null {
  const f = field.trim();
  switch (f.toLowerCase()) {
    case 'type':
      return e.type;
    case 'name':
      return e.name;
    case 'storey':
    case 'level':
      return e.storey;
    case 'material':
      return e.material?.names.join(' | ') ?? null;
    case 'volume':
      return volumeOf(e)?.value ?? null;
    case 'area':
      return areaOf(e)?.value ?? null;
    case 'id':
      return e.expressID;
  }
  const q = /^(?:q|quantity):(.+)$/i.exec(f);
  if (q) return quantity(e, q[1]!.trim());
  const p = /^(?:p|pset|prop):(.+?)\.([^.]+)$/i.exec(f);
  if (p) {
    const v = prop(e, p[1]!.trim(), p[2]!.trim());
    if (v == null) return null;
    const n = Number(v);
    return v.trim() !== '' && Number.isFinite(n) ? n : v;
  }
  // bare property name: first pset that has it
  for (const set of Object.values(e.psets ?? {})) {
    if (f in set) {
      const v = prop(e, '', f) ?? String(set[f] ?? '');
      const n = Number(v);
      return v === '' || v === f ? null : Number.isFinite(n) && v.trim() !== '' ? n : v;
    }
  }
  const qv = quantity(e, f);
  return qv;
}

export type Op = 'eq' | 'ne' | 'contains' | 'gt' | 'lt' | 'gte' | 'lte' | 'missing' | 'set';

export function compare(v: string | number | null, op: Op, want: unknown): boolean {
  switch (op) {
    case 'missing':
      return v == null;
    case 'set':
      return v != null;
    case 'eq':
      return v != null && String(v).toLowerCase() === String(want ?? '').toLowerCase();
    case 'ne':
      return v == null || String(v).toLowerCase() !== String(want ?? '').toLowerCase();
    case 'contains':
      return (
        v != null &&
        String(v)
          .toLowerCase()
          .includes(String(want ?? '').toLowerCase())
      );
    case 'gt':
      return v != null && Number(v) > Number(want);
    case 'lt':
      return v != null && Number(v) < Number(want);
    case 'gte':
      return v != null && Number(v) >= Number(want);
    case 'lte':
      return v != null && Number(v) <= Number(want);
    default:
      return true;
  }
}
